namespace appn.views.tasks.createOrEdit {

    class InitArgs {
        firstToClaimId: string = appn.emptyString;
        allToCompleteId: string = appn.emptyString;
        latLonUser: string = appn.emptyString;
        modelCanSave: boolean = false;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        addEvents();

        appn.tasks.init(_initArgs.firstToClaimId, _initArgs.allToCompleteId, true);
        appn.tasks.initAddressMap({
            completeAtLot: 'Task_CompleteAtLot',
            completeAtText: 'Task_CompleteAtText',
            completeAtCountry: 'Task_CompleteAtCountry',
            completeAtLat: 'Task_CompleteAtLat',
            completeAtLon: 'Task_CompleteAtLon'
        }, _initArgs.latLonUser, _initArgs.modelCanSave);

        appn.select.init({
            selector: 'select#iconsToDisplay',
            isIconSelect: true
        });

        if ($('nav .navbar-nav-right button[value*="Trash"]').length > 0)
            appn.trash.addTrashMessage($('nav .navbar-nav-right button[value*="Trash"]'), '#Task_Name', undefined, undefined, false);
    }

    function addEvents() {

        $('select[readonly]').each(function() {
            $(this as any).attr('data-original-value', ($(this as any).val() as string));
            $(this as any).on('change', function(i: any) {
                $(i.target).val(($(this as any).attr('data-original-value') as string));
            });
        });

        // Hook save link
        $('#saveLink').on('click', function() {
            $('form#appnForm').submit();
        });

        // On status changed
        const originalStatus = $('#Task_Status').find(':selected').text();
        $('#Task_Status').on('change', function (this: HTMLElement, e: Event) {
            const currentStatus = $(this).val();

            if (originalStatus !== currentStatus && originalStatus === appn.tasks.TaskStatus[appn.tasks.TaskStatus.InProgress]) {
                let message;
                if (currentStatus === appn.tasks.TaskStatus[appn.tasks.TaskStatus.Draft])
                    message = T(`You are about to change the status to Draft. Please note that saved activity data on the user's device may be lost. Additionally this Task will disappear from the Tasks list on the device.<br><br>Hit OK to continue.`);
                else if (currentStatus === appn.tasks.TaskStatus[appn.tasks.TaskStatus.Completed])
                    message = T(`You are about to change the status to Completed. Please note that saved activity data on the user's device may be lost. Additionally this Task will disappear from the Tasks list on the device.<br><br>Hit OK to continue.`);

                appn.dialog.confirm({
                    modalColor: 'modal-warning',
                    title: T('Task Status Change'),
                    message: message,
                    buttons: {
                        confirm: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    callback: function(result: any) {
                        if (!result)
                            $('#Task_Status').val(originalStatus);

                    }
                });
            }
        });
    }
}
